import styled from 'styled-components';

import { Colour } from '@xemplo/colours';
import {
  BodyLargeSemiBold,
  BodySmallMedium,
  BodyStandardSemiBold,
  BodyXSmallRegular,
  MinBreakpointV2,
} from '@xemplo/style-constants';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background: ${Colour.Light[100]};
  border-bottom: 1px solid ${Colour.Dark[10]};
  border-radius: 8px;

  @media ${MinBreakpointV2.medium} {
    padding: 32px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  & path {
    stroke: url(#primaryGradient);
  }
`;

export const Title = styled.span`
  ${BodyStandardSemiBold};
  color: ${Colour.Gray[800]};
  flex-grow: 1;
  @media ${MinBreakpointV2.medium} {
    ${BodyLargeSemiBold};
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.span`
  ${BodyXSmallRegular};
  color: ${Colour.Gray[400]};
`;

export const Value = styled.span`
  ${BodySmallMedium};
  color: ${Colour.Gray[600]};
`;
